import { defineComponent as _defineComponent } from 'vue';
import { computed, ref } from "vue";
import { useFileSourceTemplatesStore } from "@/stores/fileSourceTemplatesStore";
import { useInstanceAndTemplate } from "./instance";
import UpgradeForm from "./UpgradeForm.vue";
import LoadingSpan from "@/components/LoadingSpan.vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'UpgradeInstance',
    props: {
        instanceId: null
    },
    setup(__props) {
        const props = __props;
        const { instance } = useInstanceAndTemplate(ref(props.instanceId));
        const fileSourceTemplatesStore = useFileSourceTemplatesStore();
        const latestTemplate = computed(() => { var _a; return instance.value && fileSourceTemplatesStore.getLatestTemplate((_a = instance.value) === null || _a === void 0 ? void 0 : _a.template_id); });
        return { __sfc: true, props, instance, fileSourceTemplatesStore, latestTemplate, UpgradeForm, LoadingSpan };
    }
});
